import React from 'react';
import './Cards.css';
import CardItem from './CardItem';

function Cards() {
  return (
    <div id='about' style={{ display: "flex", justifyContent: "center", flexDirection: "column" }} className='cards'>
      <h1>ABOUT</h1>
      <h3 className="cards-description" >
        I'm Aman Madhav Garg, final year IB student at UWC Dover. I am interested in developing projects in Singapore for social good. I have collaborated with the Singapore Science Center, the Genesis School for Special Education and Tata Consultancy Services. Please explore my website to learn about the various projects I have completed.


      </h3>
      <img alt="me" className="pic" src="images/aman.png" />

      <div className='cards__container'>
        <h1 id="portfolio" style={{ marginTop: "30px" }}>PORTFOLIO</h1>
        <div className='cards__wrapper'>
          <ul className='cards__items'>

            <CardItem
              src='images/hydro.jpg'
              text='GrowLah! Bringing IoT enabled Hydroponics to Singapore'
              label='Collaboration with Tata Consultancy Services'
              path='/GrowLah'
            />

            <CardItem
              src='images/decodelabs1.png'
              text='decodeLabs Dyslexia platform'
              label='Dyslexia treatment'
              path='/dyslexia'
            />


          </ul>
          <ul className='cards__items'>
            <CardItem
              src='images/astar.jpg'
              text='A*STAR Research Internship'
              label='Modelling Polycrystalline depositions'
              path='/Astar'
            />
            <CardItem
              src='images/silverlion.png'
              text='Silver Lion'
              label='Promoting elder health'
              path='/SilverLion'
            />

            <CardItem
              src='images/ai.jpg'
              text='Project Lithium'
              label='Website development'
              path='/projectlithium'
            />
          </ul>



        </div>
      </div>
    </div >
  );
}

export default Cards;
